import React, { useState, useRef, useMemo } from 'react'
import _ from 'lodash'
import {
  Modal,
  Button,
  Grid,
  BaseForm as Form,
  notice,
  Axios,
  Message,
  Segment,
  Text,
  Util,
} from 'component/base'
import { Custom } from 'component/pieces'
import { Label } from 'semantic-ui-react'

export const IkkatsuKeshikomiModal = props => {
  const {
    isOpenModal,
    onClickCancel,
  } = props

  const [saimuList, setSaimuList] = useState([])
  const [loading, setLoading] = useState(false)
  const [searched, setSearched] = useState(false)
  const [isRegistered, setIsRegistered] = useState(false)
  const [searchCondition, setSearchCondition] = useState({})
  const [keijo_date, set_keijo_date] = useState('')
  const [completedCount, setCompletedCount] = useState(0)

  const mapModel = inputs => inputs
  const searchFormRef = useRef()
  const registerFormRef = useRef()
  const saimu_meimoku_kbn = searchCondition.saimu_meimoku_kbn

  const onSearch = formvalues => {
    setCompletedCount(0)
    setSearchCondition(formvalues)
    callGetApi(formvalues)
    setIsRegistered(false)
  }

  const onSearchConfirm = () => {
    searchFormRef.current.submit()
  }

  const onRegisterConfirm = () => {
    registerFormRef.current.submit()
  }

  const gokei_gaku = _.sumBy(saimuList, 'mibarai_gokei_gaku')
  const gokei_mibarai = _(saimuList)
    .groupBy('torihikisaki_id')
    .mapValues(rows => _.sumBy(rows, 'mibarai_gokei_gaku'))
    .value();
  const totalCount = useMemo(
    () => _.uniqBy(saimuList, 'torihikisaki_id').length,
    [saimuList]
  )


  const onRegister = async formvalues => {
    setLoading(true)
    setCompletedCount(0)

    const grouped = _.groupBy(saimuList, 'torihikisaki_id')

    for (const [torihikisaki_id, rows] of Object.entries(grouped)) {
      const base_list = rows
        .filter(row => !row.sonota_saimu_id)
        .map(row => ({
          ...row,
          kingaku: String(row.mibarai_gokei_gaku || 0),
          keshikomi_gaku: String(row.mibarai_gokei_gaku || 0),
        }))

      const sonota_list = rows
        .filter(row => row.sonota_saimu_id)
        .map(row => ({
          ...row,
          kingaku: String(row.mibarai_gokei_gaku || 0),
          keshikomi_gaku: String(row.mibarai_gokei_gaku || 0),
        }))

      let result = false

      switch (saimu_meimoku_kbn) {
        case 'daigae_enjokin':
          result = await callPostApi({
            torihikisaki_id,
            shiharai: [formvalues],
            daigae_enjokin_meisai: base_list,
            sonota_saimu: sonota_list,
          })
          break

        case 'haitokin':
          result = await callPostApi({
            torihikisaki_id,
            shiharai: [formvalues],
            haitokin_shosai: base_list,
            sonota_saimu: sonota_list,
          })
          break

        case 'haisha_shiharai':
          result = await callPostApi({
            torihikisaki_id,
            shiharai: [formvalues],
            haisha_shiharai_shime: base_list,
            sonota_saimu: sonota_list,
          })
          break

        case 'azukarikin':
          result = await callPostApi({
            torihikisaki_id,
            shiharai: [formvalues],
            azukarikin: base_list,
            sonota_saimu: sonota_list,
          })
          break

        default:
          break
      }

      if (!result.success) {
        setLoading(false)
        notice({
          title: 'Error',
          description: result.error.statusText,
          type: 'error',
        })
        return
      }

      setCompletedCount(c => c + 1)
    }

    setLoading(false)
    setIsRegistered(true)
    notice({
      title: 'Success',
      description: '処理が正常に終了しました',
      type: 'success',
    })

  }


  const callGetApi = async formvalues => {
    setLoading(true)

    const { data, error } = await Axios.ajax.get(`/api/staff/kumiaiin/saimu/list`,
      {
        params: {
          saimu_meimoku_kbn: formvalues.saimu_meimoku_kbn,
          torihikisaki_kbn: formvalues.torihikisaki_kbn,
          shime_date: formvalues.shime_date,
        },
      }
    )
    setLoading(false)
    if (error) return
    setSaimuList(
      _(data)
        .map((row, index) => {
          const { keshikomi_gaku, ...other } = row || {}

          return {
            ...other,
            id:
              row.daigae_enjokin_meisai_id ||
              row.haitokin_shosai_id ||
              row.haisha_shiharai_shime_id ||
              row.azukarikin_id ||
              row.sonota_saimu_id,
            key: index,
            is_keshikomi_taisho: true,
            is_sonota_saimu: row.sonota_saimu_id ? true : false,
          }
        })
        .value()
    )
    setSearched(true)
  }

  const callPostApi = async model => {
    const shiharaiPrams = (model.shiharai || []).map(row => ({
      key: row.key || Util.getRandomID(),
      kingaku: gokei_mibarai[model.torihikisaki_id] || 0,
      ...row,
    }))

    const { error } = await Axios.ajax.post(
      '/api/staff/kumiaiin/saimu/keshikomi',
      _.assign({}, model, {
        shiharai: shiharaiPrams,
        keijo_date,
        torihikisaki_id: model.torihikisaki_id,
      })
    )

    if (error) {
      return { success: false, error }
    }

    return { success: true }
  }

  const major_kbn_list = useMemo(() => {
      if (saimu_meimoku_kbn === 'daigae_enjokin') return ['kumiaiin']
      else if (saimu_meimoku_kbn === 'haitokin') return ['kumiaiin']
      else if (saimu_meimoku_kbn === 'haisha_shiharai') return ['haisha']
      else if (saimu_meimoku_kbn === 'azukarikin') return ['kumiaiin']
      else return []
    }, [saimu_meimoku_kbn])
  
  const middle_kbn_list = useMemo(() => {
    if (saimu_meimoku_kbn === 'daigae_enjokin') return ['daigae_sharyo']
    else if (saimu_meimoku_kbn === 'haitokin') return ['haitokin']
    else if (saimu_meimoku_kbn === 'haisha_shiharai')
      return ['unsoten_shiharai']
    else if (saimu_meimoku_kbn === 'azukarikin') return ['azukarikin']
    else return []
  }, [saimu_meimoku_kbn])

  const minor_kbn_list = useMemo(() => {
    if (saimu_meimoku_kbn === 'daigae_enjokin')
      return ['daigae_enjokin_shiharai']
    else if (saimu_meimoku_kbn === 'haitokin') return ['shiharai']
    else if (saimu_meimoku_kbn === 'haisha_shiharai') return []
    else if (saimu_meimoku_kbn === 'azukarikin') return ['shiharai']
    else return []
  }, [saimu_meimoku_kbn])

  return (
    <>
      <Modal
        closeOnEscape={!loading}
        closeOnDimmerClick={!loading}
        dimmer='inverted'
        onClose={onClickCancel}
        open={isOpenModal}
      >
        <Modal.Header>一括消込</Modal.Header>

        <Modal.Content>
          <Form
            id='searchForm'
            mapping={mapModel}
            onValidSubmit={onSearch}
            ref={searchFormRef}
          >
            <Grid>
              <Grid.Row columns={3}>
                <Grid.Column>
                  <Custom.Dropdown.SaimuMeimokuKbn
                    name='saimu_meimoku_kbn'
                    label='名目'
                    required
                    clearable
                  />
                </Grid.Column>
                <Grid.Column>
                  <Custom.Dropdown.TorihikisakiKbn
                    name='torihikisaki_kbn'
                    label='取引先区分'
                    required
                    clearable
                  />
                </Grid.Column>
                <Grid.Column>
                  <Form.Textbox.DatePicker
                    label='締日'
                    name='shime_date'
                    required
                    clearable
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={onClickCancel}
            content='閉じる'
            secondary
            disabled={loading}
          />
          <Button
            onClick={onSearchConfirm}
            content='検索'
            primary
            disabled={loading}
          />
        </Modal.Actions>
        {searched && (
          <>
            <Modal.Content>
              <Form
                id='registerForm'
                mapping={mapModel}
                onValidSubmit={onRegister}
                ref={registerFormRef}
              >
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={5}>
                      <Segment style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        <span>件数：</span>
                        <Text.Comma content={totalCount} />
                      </Segment>
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Segment style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        <span>合計金額：</span>
                        <Text.Comma content={gokei_gaku} />
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                  {gokei_gaku > 0 && (
                    <>
                      <Grid.Row>
                        <Grid.Column>
                          <Form.Textbox.DatePicker
                            name='keijo_date'
                            label='計上日'
                            required
                            onChange={(e, { value }) => set_keijo_date(value)}
                          />
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column>
                          <Form.Textbox.DatePicker
                            name='shiharai_date'
                            label='支払日'
                          />
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column>
                          <Custom.Dropdown.ShiwakePatternTorihiki
                            name='shiwake_pattern_torihiki_id'
                            value={saimuList.shiwake_pattern_torihiki_id}
                            label='取引種類'
                            required
                            major_kbn_list={major_kbn_list}
                            middle_kbn_list={middle_kbn_list}
                            minor_kbn_list={minor_kbn_list}
                            hassei_moto_kbn='on'
                          />
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column>
                          <Form.Textbox.Standard
                            name='tekiyo'
                            label='摘要'
                            textAreaMode
                          />
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column>
                          <Message
                            info
                            icon='info circle'
                            content={
                              <>
                                <p>
                                  指定された条件で該当する債務残高を全額で消し込みます
                                </p>
                              </>
                            }
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </>
                  )}
                </Grid>
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Label content={`全${totalCount}件中${completedCount}件完了`} size='medium' />
              <Button
                onClick={onRegisterConfirm}
                content='登録'
                primary
                disabled={gokei_gaku <= 0 || loading || isRegistered}
              />
            </Modal.Actions>
          </>
        )}
      </Modal>
    </>
  )
}